export default __webpack_public_path__ + "static/media/Map5-2.50071d90.png";